import md5 from 'spark-md5'

export default md5
